import React, { useState } from "react";

export default function ShowGeneratedSecretView({
  unlinkAddress = "2oB1kD7f8xJ3zW4yV9RnQsTmUvWxYz1aBcDeFgHiJkLmNoPqRs",
  mnemonic = "twelve correct horse battery staple example jungle village breeze dragon token brave",
  onBack,
  onContinue,
}) {
  const [copied, setCopied] = useState(null);

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(type);
      setTimeout(() => setCopied(null), 1500);
    });
  };

  const renderCopyLabel = (type) => (copied === type ? "Copied!" : "Copy");

  return (
    <div style={{ backgroundColor: "#000", color: "#fff", height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Sticky Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          padding: "1rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          onClick={onBack}
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            marginRight: "1rem",
            cursor: "pointer",
          }}
        >
          ←
        </button>
        <h2 style={{ margin: 0 }}>Your Unlink Identity</h2>
      </div>

      {/* Main Content */}
      <div
        style={{
          padding: "2rem",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          textAlign: "left",
        }}
      >
        <p style={{ color: "#ccc", marginBottom: "1rem" }}>
          This is your <strong>Unlink address</strong>. Others use it to send you messages.
          It’s safe to share — it <em>doesn't reveal your identity or recovery key</em>.
        </p>

        <div
          onClick={() => handleCopy(unlinkAddress, "address")}
          style={{
            backgroundColor: "#111",
            color: "#fff",
            padding: "2rem 0.75rem 0.75rem 0.75rem",
            borderRadius: "6px",
            wordBreak: "break-word",
            marginBottom: "1.5rem",
            border: "1px solid #333",
            fontFamily: "monospace",
            width: "100%",
            cursor: "pointer",
            position: "relative",
            boxSizing: "border-box",
          }}
        >
          {unlinkAddress}
          <span
            style={{
              position: "absolute",
              right: "0.75rem",
              top: "0.5rem",
              color: "#4e8cff",
              fontSize: "0.8rem",
            }}
          >
            {renderCopyLabel("address")}
          </span>
        </div>

        <p style={{ color: "#ccc", marginBottom: "0.5rem" }}>
          This is your recovery key. It gives full access to your Unlink address.
          Store it safely — if you lose it, there's no way to recover your messages.
        </p>

        <div
          onClick={() => handleCopy(mnemonic, "mnemonic")}
          style={{
            backgroundColor: "#111",
            color: "#fff",
            padding: "2rem 0.75rem 0.75rem 0.75rem",
            borderRadius: "6px",
            border: "1px solid #333",
            marginBottom: "2rem",
            fontFamily: "monospace",
            whiteSpace: "pre-wrap",
            width: "100%",
            cursor: "pointer",
            position: "relative",
            boxSizing: "border-box",
          }}
        >
          {mnemonic}
          <span
            style={{
              position: "absolute",
              right: "0.75rem",
              top: "0.5rem",
              color: "#4e8cff",
              fontSize: "0.8rem",
            }}
          >
            {renderCopyLabel("mnemonic")}
          </span>
        </div>

        <button
          onClick={onContinue}
          style={{
            padding: "0.5rem 1rem",
            fontSize: "1rem",
            borderRadius: "4px",
            border: "none",
            backgroundColor: "#4e8cff",
            color: "#fff",
            cursor: "pointer",
            width: "100%",
            maxWidth: "250px",
          }}
        >
          I’ve saved my key
        </button>
      </div>
    </div>
  );
}